import {useMutation, type UseMutationOptions} from '@tanstack/react-query';
import {
	userSelfRegistration,
	type UserSelfRegistrationResult,
	type UserSelfRegistrationRequestOptions,
	type QueryError,
} from '../userSelfRegistration';
export * from '../userSelfRegistration';

export type UseReactQueryUserSelfRegistrationOptions = Omit<
	UseMutationOptions<
		UserSelfRegistrationResult,
		QueryError,
		UserSelfRegistrationRequestOptions,
		UserSelfRegistrationResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof userSelfRegistration;
};

export const useReactQueryUserSelfRegistration = ({
	mutationFn = userSelfRegistration,
	...options
}: UseReactQueryUserSelfRegistrationOptions = {}) =>
	useMutation<
		UserSelfRegistrationResult,
		QueryError,
		UserSelfRegistrationRequestOptions,
		UserSelfRegistrationResult
	>({
		mutationFn,
		...options,
	});

export default useReactQueryUserSelfRegistration;
